export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_01.1fa0de6a.png";